export const queryKey = {
    paragraphs: () => ['paragraphs'],
};
